// extracted by mini-css-extract-plugin
export default {"container":"DanhGiaMonTong_container__oF0-G","table":"DanhGiaMonTong_table__EvFsa"};